import {reducer as news} from './newsReducer'
import {reducer as user} from './userReducer'
import {combineReducers} from 'redux'
import {reducer as http} from './httpReducer'
import {reducer as dev} from './devManagerReducer'
import {reducer as company} from './companyReducer'
import {reducer as usermanager} from './userManagerReducer'
import {reducer as agent} from './agentReducer'
import {reducer as project} from './projectReducer'
import {reducer as alarm} from './alarmReducer'
import {reducer as res} from './resReducer'
import {reducer as replace} from './replaceReducer'
import {reducer as group} from './groupReducer'
import {reducer as share} from './shareReducer'
import {reducer as refresh} from './refreshPageReducer'

const initialState = {
    isFetching: true,
    msg: {
        type: 1,//0失败 1成功
        content: ''
    },
    userInfo: {}
};

export const actionsTypes = {
    FETCH_START: "FETCH_START",
    FETCH_END: "FETCH_END",
    USER_LOGIN: "USER_LOGIN",
    USER_REGISTER: "USER_REGISTER",
    RESPONSE_USER_INFO: "RESPONSE_USER_INFO",
    SET_MESSAGE: "SET_MESSAGE",
    USER_AUTH:"USER_AUTH"
};

export const actions = {
    get_login: function (username, password) {
        return {
            type: actionsTypes.USER_LOGIN,
            username,
            password
        }
    },
    get_register: function (data) {
        return {
            type: actionsTypes.USER_REGISTER,
            data
        }
    },
    clear_msg: function () {
        return {
            type: actionsTypes.SET_MESSAGE,
            msgType: 1,
            msgContent: ''
        }
    },
    user_auth:function () {
        return{
            type:actionsTypes.USER_AUTH
        }
    }
};

export function reducer(state = initialState, action) {
    switch (action.type) {
        case actionsTypes.FETCH_START:
            return {
                ...state, isFetching: true
            };
        case actionsTypes.FETCH_END:
            return {
                ...state, isFetching: false
            };
        case actionsTypes.SET_MESSAGE:
            return {
                ...state,
                isFetching: false,
                msg: {
                    type: action.msgType,
                    content: action.msgContent
                }
            };
        case actionsTypes.RESPONSE_USER_INFO:
            return {
                ...state, userInfo: action.data
            };
        default:
            return state
    }
}

export default {
    news,
    user,
    http,
    dev,
    company,
    usermanager,
    agent,
    project,
    alarm,
    res,
    replace,
    group,
    share,
    refresh,
    globalState: reducer
}

/*
export default combineReducers({
    news,
    user,
    globalState: reducer
})*/



// WEBPACK FOOTER //
// ./src/reducers/index.js